export enum ImageFormat {
  Jpg = 1,
  Jpeg,
  Png,
  Gif,
  Bmp
}
